// frontend/src/services/clientExtraFieldService.js
import api from './api';

const BASE = '/client-extra-fields';

export default {
  // pou ClientModal
  listActive: () =>
    api.get(`${BASE}/active`, { params: { functionCode: 'CLIENT_VIEW' } })
       .then(r => r.data),

  // admin
  list: params =>
    api.get(BASE, { params: { functionCode: 'CLIENT_FIELD_VIEW', ...params } })
       .then(r => r.data),
  get: id =>
    api.get(`${BASE}/${id}`, { params: { functionCode: 'CLIENT_FIELD_VIEW' } })
       .then(r => r.data),
  create: data =>
    api.post(`${BASE}`, { ...data, functionCode: 'CLIENT_FIELD_CREATE' })
       .then(r => r.data),
  update: (id, data) =>
    api.put(`${BASE}/${id}`, { ...data, functionCode: 'CLIENT_FIELD_UPDATE' })
       .then(r => r.data),
  remove: id =>
    api.delete(`${BASE}/${id}`, { data: { functionCode: 'CLIENT_FIELD_DELETE' } })
       .then(r => r.data),
};
